import React from "react";

export default ({insects, index, getInsectById, selectInsect, showContact}) => {

    return <div className="question question--insects">
        <div className="question__inner">
            <h4 className="question__number">{index}.</h4>
            <h3 className="question__question">Can you find it below</h3>
            <div className="question__options">
                <ul>
                    <li><a href="#" className="btn btn--blue--hollow btn--blue"
                           onClick={(e) => {
                               e.preventDefault();
                               showContact();
                               return false;
                           }}>Its not in the list below</a></li>
                </ul>
            </div>
            <ul className="question__insect-list">
                {insects.map((selectedInsectId) => {
                    const insect = getInsectById(selectedInsectId)
                    return <li key={'ib__' + insect.id}>
                        <a href="#" className="question__insect" onClick={(e) => {
                            e.preventDefault();
                            selectInsect(insect)
                            return false;
                        }}>
                            <div className="question__insect__image"
                                 style={{backgroundImage: 'url(' + insect.insect_image + ')'}}></div>
                            <h3>{insect.title}</h3>
                        </a>
                    </li>;
                })}
            </ul>
        </div>
    </div>

}
